"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var QuoteSectionStore_1 = __importStar(require("./QuoteSectionStore"));
var Section_1 = require("QuoteV2/Models/Section");
var CalculateQuote_1 = require("QuoteV2/Calculator/CalculateQuote");
var AngularSyncStore_1 = __importStar(require("Utils/AngularSyncStore"));
var lodash_1 = require("lodash");
var Types_1 = require("@CommonFrontendBackend/QuoteV2/Types");
var DiscountStore_1 = __importStar(require("./DiscountStore"));
var omitByDeep_1 = __importDefault(require("@CommonFrontendBackend/Utils/omitByDeep"));
var inversify_1 = require("inversify");
var CalculatorService_1 = __importDefault(require("QuoteV2/Calculator/CalculatorService"));
var VariableStore_1 = __importDefault(require("./VariableStore"));
var BillingScheduleOrchestrator_1 = require("QuoteV2/BillingSchedule/BillingScheduleOrchestrator");
var QuoteItemStore_1 = require("./QuoteItemStore");
var QuoteBlockStore = (function (_super) {
    __extends(QuoteBlockStore, _super);
    function QuoteBlockStore(angularData, calculatorService, variableStore, billingScheduleOrchestrator, syncServices) {
        var _this = _super.call(this, angularData, syncServices, {
            extractDataFromAngular: function (data) {
                return (0, omitByDeep_1.default)(data, function (key) { return (key !== "$id" && key.startsWith("$")) || key === "contentAreas"; });
            },
            getArrayItemId: function (obj) { return obj === null || obj === void 0 ? void 0 : obj.$id; },
            debounceSync: true,
        }) || this;
        _this.setSectionSelection = function (section, selected) {
            section.selected = selected;
            if (!selected && section.displayMode === Types_1.QuoteSectionDisplayMode.PlanCards) {
                section.items.forEach(function (item) {
                    _this.setItemSelection(section, item, false);
                });
            }
            if (selected && _this.quoteSelectionType === Types_1.QuoteSelectionType.Single) {
                _this.sections
                    .filter(function (sibling) { return sibling.id !== section.id; })
                    .forEach(function (sibling) {
                    _this.setSectionSelection(sibling, false);
                });
            }
        };
        _this.setItemSelection = function (section, item, selected) {
            if ((0, QuoteItemStore_1.supportsInteractivePricing)(item)) {
                item.isOptionalSelected = selected;
            }
            if (selected && section.itemSingleSelect) {
                var siblingItems = section.items.filter(function (sibling) { return sibling.id !== item.id; });
                siblingItems.forEach(function (siblingItem) {
                    _this.setItemSelection(section, siblingItem, false);
                });
            }
            if (selected && section.displayMode === Types_1.QuoteSectionDisplayMode.PlanCards) {
                _this.setSectionSelection(section, true);
            }
            if (!selected && section.displayMode === Types_1.QuoteSectionDisplayMode.PlanCards) {
                var allItemsUnselected = section.items.every(function (item) { return !(0, QuoteItemStore_1.supportsInteractivePricing)(item) || !item.isOptional || !item.isOptionalSelected; });
                if (allItemsUnselected) {
                    section.selected = false;
                }
            }
        };
        _this.onAngularUpdated = function (newData) {
            var _a;
            _this.blockData = newData;
            _this._currency = newData.settings.currency;
            _this._labelSetId = newData.settings.labelSetId;
            _this.discountStore = new DiscountStore_1.default((_a = newData.discount) !== null && _a !== void 0 ? _a : DiscountStore_1.defaultDiscount);
            var sections = newData.sections;
            var inSingleSelectionMode = _this.blockData.selectionType === Types_1.QuoteSelectionType.Single;
            var selectedSectionCount = newData.sections.filter(function (section) { return section.selected; }).length;
            if (inSingleSelectionMode && selectedSectionCount > 1) {
                sections = sections.map(function (section) { return (__assign(__assign({}, section), { selected: false })); });
            }
            _this.sectionStores = sections.map(function (section) { return new QuoteSectionStore_1.default(section, _this.currency, _this.services); });
        };
        _this.services = { calculatorService: calculatorService, variableStore: variableStore, billingScheduleOrchestrator: billingScheduleOrchestrator };
        _this.onAngularUpdated(angularData);
        return _this;
    }
    Object.defineProperty(QuoteBlockStore.prototype, "showTotalExcludingTaxes", {
        get: function () {
            return this.blockData.settings.view.showExTax;
        },
        set: function (show) {
            var _this = this;
            (0, mobx_1.runInAction)(function () {
                _this.blockData.settings.view.showExTax = show;
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuoteBlockStore.prototype, "showTotalDiscounts", {
        get: function () {
            return this.blockData.settings.view.showTotalDiscount;
        },
        set: function (show) {
            var _this = this;
            (0, mobx_1.runInAction)(function () {
                _this.blockData.settings.view.showTotalDiscount = show;
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuoteBlockStore.prototype, "showTaxTotals", {
        get: function () {
            return this.blockData.settings.view.showTaxTotals;
        },
        set: function (show) {
            var _this = this;
            (0, mobx_1.runInAction)(function () {
                _this.blockData.settings.view.showTaxTotals = show;
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuoteBlockStore.prototype, "showSectionLabels", {
        get: function () {
            var _a;
            return (_a = this.blockData.settings.view.showSectionIds) !== null && _a !== void 0 ? _a : false;
        },
        enumerable: false,
        configurable: true
    });
    QuoteBlockStore.prototype.getSectionLabel = function (section) {
        var index = this.sections.findIndex(function (x) { return section.id === x.id; });
        var shouldUseLetterOrdering = this.quoteSelectionType !== Types_1.QuoteSelectionType.Combined;
        if (shouldUseLetterOrdering) {
            return this.counterToLetters(index);
        }
        return "".concat(index + 1);
    };
    QuoteBlockStore.prototype.counterToLetters = function (counter) {
        var letterString = "";
        var BASE = 26;
        while (true) {
            var digitValue = (counter % BASE) + 1;
            counter = (counter - digitValue) / BASE;
            var digitChar = String.fromCharCode(64 + digitValue);
            letterString = "".concat(digitChar).concat(letterString);
            if (counter <= 0) {
                break;
            }
        }
        return letterString;
    };
    Object.defineProperty(QuoteBlockStore.prototype, "showQuoteTotals", {
        get: function () {
            var _a;
            return (_a = this.blockData.settings.view.showQuoteTotals) !== null && _a !== void 0 ? _a : true;
        },
        set: function (show) {
            this.blockData.settings.view.showQuoteTotals = show;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuoteBlockStore.prototype, "sections", {
        get: function () {
            return this.sectionStores;
        },
        enumerable: false,
        configurable: true
    });
    QuoteBlockStore.prototype.createNewSection = function (afterId, mode) {
        var newSection = new QuoteSectionStore_1.default((0, Section_1.BaseSectionModel)(mode), this.currency, this.services);
        var afterIndex = this.sections.findIndex(function (section) { return section.id === afterId; });
        var insertIndex = afterIndex !== -1 ? afterIndex + 1 : this.sections.length;
        this.sectionStores.splice(insertIndex, 0, newSection);
    };
    Object.defineProperty(QuoteBlockStore.prototype, "total", {
        get: function () {
            return this.services.calculatorService.calculateQuote(this.dataForAngular);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuoteBlockStore.prototype, "quoteSelectionType", {
        get: function () {
            return this.dataForAngular.selectionType;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuoteBlockStore.prototype, "currency", {
        get: function () {
            return this._currency;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuoteBlockStore.prototype, "labelSetId", {
        get: function () {
            return this._labelSetId;
        },
        enumerable: false,
        configurable: true
    });
    QuoteBlockStore.prototype.deleteSection = function (section) {
        var index = (0, lodash_1.findIndex)(this.sections, function (x) { return x.id === section.id; });
        this.sectionStores.splice(index, 1);
    };
    QuoteBlockStore.prototype.reorderSection = function (section, direction) {
        var _a;
        var from = this.sections.findIndex(function (x) { return x.id === section.id; });
        var to = (0, lodash_1.clamp)((_a = {},
            _a[QuoteSectionStore_1.ReorderDirection.Up] = from - 1,
            _a[QuoteSectionStore_1.ReorderDirection.Down] = from + 1,
            _a)[direction], 0, this.sections.length - 1);
        this.sectionStores.splice(from, 1);
        this.sectionStores.splice(to, 0, section);
    };
    QuoteBlockStore.prototype.cloneSection = function (section) {
        var currentIndex = this.sections.findIndex(function (x) { return section.id === x.id; });
        var isSingleSelect = this.dataForAngular.selectionType === Types_1.QuoteSelectionType.Single;
        var sectionToClone = (0, lodash_1.cloneDeep)(section);
        this.cleanSelectionState(isSingleSelect, sectionToClone);
        this.cleanIntegrationData(sectionToClone);
        var clone = new QuoteSectionStore_1.default((0, lodash_1.omit)(sectionToClone.angularModel, isSingleSelect ? ["$id", "selected"] : "$id"), this.currency, this.services);
        this.sectionStores.splice(currentIndex + 1, 0, clone);
    };
    QuoteBlockStore.prototype.cleanSelectionState = function (isSingleSelect, section) {
        if (isSingleSelect && section.displayMode === Types_1.QuoteSectionDisplayMode.PlanCards) {
            section.angularModel.items = section.angularModel.items.map(function (item) {
                var _a;
                if ((_a = item.interactive) === null || _a === void 0 ? void 0 : _a.isOptionalSelected) {
                    return __assign(__assign({}, item), { interactive: __assign(__assign({}, item.interactive), { isOptionalSelected: false }) });
                }
                else {
                    return item;
                }
            });
        }
    };
    QuoteBlockStore.prototype.cleanIntegrationData = function (section) {
        section.angularModel.items = section.angularModel.items.map(function (item) {
            if (item.type === Types_1.QuoteItemType.FixedCost && item.integrations) {
                return (0, lodash_1.omit)(item, "integrations");
            }
            return item;
        });
    };
    Object.defineProperty(QuoteBlockStore.prototype, "dataForAngular", {
        get: function () {
            return __assign(__assign({}, this.blockData), { settings: __assign(__assign({}, this.blockData.settings), { currency: this._currency, labelSetId: this._labelSetId }), sections: this.sectionStores.map(function (section) { return section.angularModel; }), discount: this.discount.angularModel });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuoteBlockStore.prototype, "discount", {
        get: function () {
            return this.discountStore;
        },
        enumerable: false,
        configurable: true
    });
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    __decorate([
        mobx_1.observable.deep,
        __metadata("design:type", typeof (_a = typeof QuoteBlockType !== "undefined" && QuoteBlockType) === "function" ? _a : Object)
    ], QuoteBlockStore.prototype, "blockData", void 0);
    __decorate([
        mobx_1.observable.deep,
        __metadata("design:type", Array)
    ], QuoteBlockStore.prototype, "sectionStores", void 0);
    __decorate([
        mobx_1.observable.deep,
        __metadata("design:type", typeof (_b = typeof DiscountStore_1.default !== "undefined" && DiscountStore_1.default) === "function" ? _b : Object)
    ], QuoteBlockStore.prototype, "discountStore", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", String)
    ], QuoteBlockStore.prototype, "_currency", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", String)
    ], QuoteBlockStore.prototype, "_labelSetId", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], QuoteBlockStore.prototype, "showTotalExcludingTaxes", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], QuoteBlockStore.prototype, "showTotalDiscounts", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], QuoteBlockStore.prototype, "showTaxTotals", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], QuoteBlockStore.prototype, "showSectionLabels", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], QuoteBlockStore.prototype, "showQuoteTotals", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [])
    ], QuoteBlockStore.prototype, "sections", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_c = typeof CalculateQuote_1.CalculatedQuote !== "undefined" && CalculateQuote_1.CalculatedQuote) === "function" ? _c : Object),
        __metadata("design:paramtypes", [])
    ], QuoteBlockStore.prototype, "total", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_d = typeof Types_1.QuoteSelectionType !== "undefined" && Types_1.QuoteSelectionType) === "function" ? _d : Object),
        __metadata("design:paramtypes", [])
    ], QuoteBlockStore.prototype, "quoteSelectionType", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], QuoteBlockStore.prototype, "setSectionSelection", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], QuoteBlockStore.prototype, "setItemSelection", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], QuoteBlockStore.prototype, "currency", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], QuoteBlockStore.prototype, "labelSetId", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_e = typeof QuoteSectionStore_1.default !== "undefined" && QuoteSectionStore_1.default) === "function" ? _e : Object]),
        __metadata("design:returntype", void 0)
    ], QuoteBlockStore.prototype, "deleteSection", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_f = typeof QuoteSectionStore_1.default !== "undefined" && QuoteSectionStore_1.default) === "function" ? _f : Object, typeof (_g = typeof QuoteSectionStore_1.ReorderDirection !== "undefined" && QuoteSectionStore_1.ReorderDirection) === "function" ? _g : Object]),
        __metadata("design:returntype", void 0)
    ], QuoteBlockStore.prototype, "reorderSection", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_h = typeof QuoteSectionStore_1.default !== "undefined" && QuoteSectionStore_1.default) === "function" ? _h : Object]),
        __metadata("design:returntype", void 0)
    ], QuoteBlockStore.prototype, "cloneSection", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_j = typeof QuoteBlockType !== "undefined" && QuoteBlockType) === "function" ? _j : Object),
        __metadata("design:paramtypes", [])
    ], QuoteBlockStore.prototype, "dataForAngular", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], QuoteBlockStore.prototype, "onAngularUpdated", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_k = typeof DiscountStore_1.default !== "undefined" && DiscountStore_1.default) === "function" ? _k : Object),
        __metadata("design:paramtypes", [])
    ], QuoteBlockStore.prototype, "discount", null);
    QuoteBlockStore = __decorate([
        (0, inversify_1.injectable)(),
        __param(0, (0, inversify_1.inject)("block")),
        __param(3, (0, inversify_1.inject)("billingScheduleOrchestrator")),
        __param(4, (0, inversify_1.inject)(AngularSyncStore_1.AngularSyncServices.$)),
        __metadata("design:paramtypes", [typeof (_l = typeof QuoteBlockType !== "undefined" && QuoteBlockType) === "function" ? _l : Object, typeof (_m = typeof CalculatorService_1.default !== "undefined" && CalculatorService_1.default) === "function" ? _m : Object, typeof (_o = typeof VariableStore_1.default !== "undefined" && VariableStore_1.default) === "function" ? _o : Object, typeof (_p = typeof BillingScheduleOrchestrator_1.BillingScheduleOrchestrator !== "undefined" && BillingScheduleOrchestrator_1.BillingScheduleOrchestrator) === "function" ? _p : Object, typeof (_q = typeof AngularSyncStore_1.AngularSyncServices !== "undefined" && AngularSyncStore_1.AngularSyncServices) === "function" ? _q : Object])
    ], QuoteBlockStore);
    return QuoteBlockStore;
}(AngularSyncStore_1.default));
exports.default = QuoteBlockStore;
